<template>
    <div class="container-fluid h-100 bg">
      <div class="row h-100">
        <div class="h-100 offset-4 d-flex align-items-center justify-content-center mx-auto" style="width: 350px;">
          <div class="card w-100 shadow">
            <div class="card-body">
              <div class="text-center my-5">
                <img src="/img/logo-openfiber.png" alt="" class="w-50"/>
              </div>
                  <div class="form-group">
                    <!-- <label for="email">{{dicts.label_username[dicts.lang]}}</label> -->
                    <input type="email" class="form-control" name="email" v-model="username" id="email" v-on:keyup.enter="loginNow" required autofocus placeholder="Akun Login" title="Akun Login">
                  </div>
                  <div class="form-group my-4">
                    <!-- <label for="password">{{dicts.label_password[dicts.lang]}}</label> -->
                    <input id="password" :type="[passVisible?'text':'password']" class="form-control" v-model="password" name="password" v-on:keyup.enter="loginNow" required placeholder="Kata Sandi" title="Kata Sandi">
                    <div class="w-100 text-left pt-2"><a href="#" class="text-secondary" v-on:click="passVisible=!passVisible" ><i class="fa field-icon" :class="[passVisible ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i></a></div>
                  </div>
                  <div class="w-100 align-items-center justify-content-start" v-if="error">
                    <div class="alert alert-danger" role="alert">
                      Periksa kembali detail login anda.
                    </div>
                  </div>
                  <!-- <div class="w-100 align-items-center justify-content-start" v-if="loading">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div> 
                    Tunggu sebentar
                  </div> -->
                  <div class="text-center mb-5">
                    <button class="btn btn-info btn-block" type="submit" v-on:click="loginNow">
                      <b-spinner v-if="loading" type="grow" small label="Small Spinner" class="mr-1"></b-spinner>{{dicts.label_login_button[dicts.lang]}}</button>
                  </div>
            </div>
          </div>

        </div>
      </div>
  </div>
</template>
<script>
  // import ChartCard from 'src/components/Cards/ChartCard.vue'
  // import StatsCard from 'src/components/Cards/StatsCard.vue'
  // import LTable from 'src/components/Table.vue'
  import {EventBus} from '../eventbus'
  import * as axios from 'axios';
  export default {
    components: {
      // LTable,
      // ChartCard,
      // StatsCard
    },
    methods:{
      loginNow(){
        // console.log(this.$baseUrl)
        if(this.username!='' && this.password!=''){
          this.loading=true;
          this.error=false;
          axios.post(this.$baseUrl+'/oauth/token',{
           username:this.username,
           password:this.password,
           grant_type:'password',
           client_id:'9371909b-625c-43a1-9016-43b0170887c9',
           client_secret:'TVhNQNB8Unmb3teKS8PKWFsEcQ4qGfQrqdu6B84W'
            // client_id:"9245ac08-dc4a-48e2-8cdc-313767717ed1",
            // client_secret:"hsi8H6HbSo4qBSUPYfWgdgdKy1yOlyps9NwP7FHV",
          }).then((result)=>{
            if(result.status==200){
              localStorage.setItem('accessToken',result.data.access_token);
              localStorage.setItem('refreshToken',result.data.refresh_token);
              this.whoami((whoamiResult)=>{
                console.log(whoamiResult)
                this.$router.push('/admin/home')
                console.log(localStorage.getItem('currentUser'))
              })
            }else{
              this.error=true;
            }
            this.loading=false;
          }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
            this.loading=false;
            this.error=true;
            console.log(err)
          })
        }
      },
      whoami(callback){
        axios.get(this.$baseUrl+'/api/whoami',{
                'headers':
                    {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
            }).then((result)=>{
            if(result.status==200){
              localStorage.setItem('currentUser',result.data.user.name);
              console.log('setrole',result.data.user);
              localStorage.setItem('role',result.data.user.role);
              callback(true)
            }else{
              callback(false)
            }
          }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
            callback(false)
          })
      }
    },
    created(){
      if(localStorage.getItem('accessToken')){
        this.$router.push('/admin/home')
      }
      EventBus.$on('lang',()=>{
        this.dicts.lang = localStorage.getItem('lang');
      })
    },
    data () {
      return {
        username:'',
        password:'',
        loading:false,
        error:false,
        passVisible:false,
        dicts:{
          lang:'id',
          label_username:{
            id:"akun login",
            en:"username"
          },
          label_password:{
            id:"Kata sandi",
            en:"password"
          },
          label_login_button:{
            id:"Masuk",
            en:"Login"
          }
        }
        // editTooltip: 'Edit Task',
        // deleteTooltip: 'Remove',
        // pieChart: {
        //   data: {
        //     labels: ['40%', '20%', '40%'],
        //     series: [40, 20, 40]
        //   }
        // },
        // lineChart: {
        //   data: {
        //     labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
        //     series: [
        //       [287, 385, 490, 492, 554, 586, 698, 695],
        //       [67, 152, 143, 240, 287, 335, 435, 437],
        //       [23, 113, 67, 108, 190, 239, 307, 308]
        //     ]
        //   },
        //   options: {
        //     low: 0,
        //     high: 800,
        //     showArea: false,
        //     height: '245px',
        //     axisX: {
        //       showGrid: false
        //     },
        //     lineSmooth: true,
        //     showLine: true,
        //     showPoint: true,
        //     fullWidth: true,
        //     chartPadding: {
        //       right: 50
        //     }
        //   },
        //   responsiveOptions: [
        //     ['screen and (max-width: 640px)', {
        //       axisX: {
        //         labelInterpolationFnc (value) {
        //           return value[0]
        //         }
        //       }
        //     }]
        //   ]
        // },
        // barChart: {
        //   data: {
        //     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        //     series: [
        //       [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
        //       [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
        //     ]
        //   },
        //   options: {
        //     seriesBarDistance: 10,
        //     axisX: {
        //       showGrid: false
        //     },
        //     height: '245px'
        //   },
        //   responsiveOptions: [
        //     ['screen and (max-width: 640px)', {
        //       seriesBarDistance: 5,
        //       axisX: {
        //         labelInterpolationFnc (value) {
        //           return value[0]
        //         }
        //       }
        //     }]
        //   ]
        // },
        // tableData: {
        //   data: [
        //     {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
        //     {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
        //     {
        //       title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
        //       checked: true
        //     },
        //     {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
        //     {title: 'Read "Following makes Medium better"', checked: false},
        //     {title: 'Unfollow 5 enemies from twitter', checked: false}
        //   ]
        // }
      }
    }
  }
</script>
<style>
.app{
  height:100vh;
}
.bg{
  background:url('/img/background-openfiber.jpg');
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
<style scoped>
.field-icon {
  float: right;
  margin-right: 10px;
  margin-top: -35px;
  position: relative;
  z-index: 2;
}
.btn {
  padding: 5px 10px !important;
  width: 300px;
  margin: auto;
  border-radius: 20px;
  background-color: #1297FD;
  color: #FFFFFF;
}
.card {
  border-radius: 50px;
}
.form-group {
  width: 300px;
  margin: auto;
}
.form-control {
  border-radius: 20px;
}
</style>
<style scoped>
/* .spinner-border {
  width: 1rem;
  height: 1rem;
} */
</style>
